import React from "react";

import { useFormContext, useFormState } from "react-hook-form";
import {
  FloatLabelInput,
  InputWithError as InputWithErrorBase
} from "@silversea-ssc/ui-components-react";
import { ErrorMessage } from "@hookform/error-message";

interface InputWithErrorProps {
  name: string;
  label: string;
  autocomplete?: string;
  id: string;
  children: FloatLabelInput;
  forceLabelRenderAsFocused?: boolean;
}

const InputWithError: React.FC<React.PropsWithChildren<InputWithErrorProps>> = (
  props
) => {
  const { name } = props;

  const { control } = useFormContext();
  const { errors } = useFormState({ control });

  const hasError = errors && Object.keys(errors).includes(name);

  const errorMessageComponent = (
    <ErrorMessage
      data-testid="input-error"
      as="div"
      errors={errors}
      name={name}
    />
  );

  return (
    <InputWithErrorBase
      {...props}
      validationState={hasError ? "error" : undefined}
      errorMessageComponent={errorMessageComponent}
    />
  );
};

export default InputWithError;
